export default __webpack_public_path__ + "static/media/citi.c1167189.svg";